var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M8 6.5A1.5 1.5 0 1 0 8 9.5A1.5 1.5 0 1 0 8 6.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7496c4",
    d: "M8,7c0.551,0,1,0.449,1,1S8.551,9,8,9S7,8.551,7,8S7.449,7,8,7 M8,6C6.895,6,6,6.895,6,8 s0.895,2,2,2s2-0.895,2-2S9.105,6,8,6L8,6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M8 1.5A1.5 1.5 0 1 0 8 4.5A1.5 1.5 0 1 0 8 1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7496c4",
    d: "M8,2c0.551,0,1,0.449,1,1S8.551,4,8,4S7,3.551,7,3S7.449,2,8,2 M8,1C6.895,1,6,1.895,6,3 s0.895,2,2,2s2-0.895,2-2S9.105,1,8,1L8,1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M8 11.5A1.5 1.5 0 1 0 8 14.5A1.5 1.5 0 1 0 8 11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7496c4",
    d: "M8,12c0.551,0,1,0.449,1,1s-0.449,1-1,1s-1-0.449-1-1S7.449,12,8,12 M8,11c-1.105,0-2,0.895-2,2 s0.895,2,2,2s2-0.895,2-2S9.105,11,8,11L8,11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.6758da308550c716ed3a67bbc7fadf14.svg";
export { ForwardRef as ReactComponent };